import {
  TooltipContent,
  TooltipRoot,
  TooltipTrigger,
} from "prosekit/react/tooltip";
import type { ReactNode } from "react";
import classNames from "classnames";

export default function ToolbarButton({
  pressed,
  disabled,
  onClick,
  tooltip,
  children,
}: {
  pressed?: boolean;
  disabled?: boolean;
  onClick?: VoidFunction;
  tooltip?: string;
  children: ReactNode;
}) {
  return (
    <TooltipRoot>
      <TooltipTrigger className="block">
        <button
          type="button"
          data-state={pressed ? "on" : "off"}
          disabled={disabled}
          onClick={() => onClick?.()}
          onMouseDown={(event) => event.preventDefault()}
          className={classNames(
            "outline-unset focus-visible:outline-unset flex items-center justify-center rounded-md p-2 font-medium transition focus-visible:ring-2 text-sm focus-visible:ring-gray-900 disabled:pointer-events-none min-w-9 min-h-9 text-gray-900 disabled:text-gray-900/50/50 bg-transparent hover:bg-gray-100 data-[state=on]:bg-gray-200",
            { "h-11 min-w-11 text-lg!": window.isApp },
          )}
        >
          {children}
          {tooltip ? <span className="sr-only">{tooltip}</span> : null}
        </button>
      </TooltipTrigger>
      {tooltip ? (
        <TooltipContent className="z-50 overflow-hidden rounded-md border border-solid bg-gray-900 px-3 py-1.5 text-xs text-gray-50 shadow-sm [&:not([data-state])]:hidden will-change-transform data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0 data-[state=open]:zoom-in-95 data-[state=closed]:zoom-out-95 data-[state=open]:animate-duration-150 data-[state=closed]:animate-duration-200 data-[side=bottom]:slide-in-from-top-2 data-[side=bottom]:slide-out-to-top-2 data-[side=left]:slide-in-from-right-2 data-[side=left]:slide-out-to-right-2 data-[side=right]:slide-in-from-left-2 data-[side=right]:slide-out-to-left-2 data-[side=top]:slide-in-from-bottom-2 data-[side=top]:slide-out-to-bottom-2">
          {tooltip}
        </TooltipContent>
      ) : null}
    </TooltipRoot>
  );
}
